<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title"><nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/argentina')"></nuxt-link> Producers</div>
                    <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/argentina/salta/bodega-el-esterco')">Bodega El Esterco</nuxt-link>
                    <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/argentina/salta/bodegas-etchart')">Bodegas Etchart</nuxt-link>
                    <nuxt-link class="wine-guide-country" :to="localePath('/wine-guide/argentina/salta/finca-quara-winery')">Finca Quara Winery</nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title"><nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/argentina')"></nuxt-link> Producers</div>
                    <v-select
                            :items="items"
                            v-model="select"
                            label="Please choose"
                            single-line
                            item-text="report"
                            item-value="src"
                            return-object
                            class="show-mobile"
                            v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Salta</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Da non dimenticare come regione vinicola dell'Argentina è Salta, nell'estremo nord del paese. Salta ospita il vigneto più alto del mondo (oltre 3.000 metri sul livello del mare!). La regione sta ancora emergendo, ma gli esperti nutrono grandi speranze, quindi torniamo tutti a Salta tra un paio d'anni circa. Bodegas Etchart e Finca Quara stanno aprendo la strada per la zona con le loro miscele di Cabernet Sauvignon, Chardonnay, Malbec, Merlot e Cabernet Franc e stanno contribuendo a mettere finalmente sulla mappa i vini pregiati di Salta.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Salta</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Als argentinische Weinregion darf man Salta im äußersten Norden des Landes nicht vergessen. Salta ist die Heimat des höchsten Weinbergs der Welt (über 3.000 Meter über dem Meeresspiegel!). Die Region ist noch im Entstehen begriffen, aber Experten haben große Hoffnungen, also kehren wir alle in ein paar Jahren oder so nach Salta zurück. Bodegas Etchart und Finca Quara sind mit ihren Mischungen aus Cabernet Sauvignon, Chardonnay, Malbec, Merlot und Cabernet Franc wegweisend für die Region und tragen dazu bei, dass die erlesenen Weine von Salta endlich bekannt werden.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Salta</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Salta, à l'extrême nord du pays, est une région viticole argentine à ne pas oublier. Salta abrite le vignoble le plus haut du monde (plus de 3 000 mètres d'altitude !). La région est encore en train d'émerger, mais les experts ont de grands espoirs, alors revenons tous à Salta dans quelques années. Bodegas Etchart et Finca Quara ouvrent la voie pour la région avec leurs assemblages de Cabernet Sauvignon, Chardonnay, Malbec, Merlot et Cabernet Franc et contribuent à mettre enfin les vins fins de Salta sur la carte.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Salta</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Not to be forgotten as an Argentina fine wine region is Salta, in the far north of the country. Salta is home to the world’s highest vineyard (over 3,000 metres above sea level!). The region is still emerging but experts have high hopes, so lets all circle back to Salta in a couple of years or so. Bodegas Etchart and Finca Quara are leading the way for the area with their Cabernet Sauvignon, Chardonnay, Malbec, Merlot and Cabernet Franc blends and helping to put Salta’s fine wines finally on the map.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Salta",
        data () {
            return {
                select: { report: 'Please choose', src: '#' },
                items: [
                    { report: 'Bodega El Esterco', src: '/wine-guide/argentina/salta/bodega-el-esterco' },
                    { report: 'Bodegas Etchart', src: '/wine-guide/argentina/salta/bodegas-etchart' },
                    { report: 'Finca Quara Winery', src: '/wine-guide/argentina/salta/finca-quara-winery' }
                ]
            }
        },
        methods: {
            changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
        },
        head: {
            title: 'Salta fine wine | Vindome Wine Guide',
            meta: [
                {
                    hid: 'description',
                    name: 'description',
                    content: 'Explore the flavors and beauty of the Salta wine region, located in the high Andes mountains of Argentina. Taste the expertly crafted Torrontes, Malbec, and other varietals that showcase the unique terroirs and rich winemaking heritage of Salta. Indulge in the essence of adventure with every sip from Salta.'
                }
            ],
            bodyAttrs: {
                class: 'wine-guide inner-page'
            }
        }
    }
</script>

<style scoped>
    .container {
        max-width: 1170px;
        padding: 0;
        font-family: 'Poppins', sans-serif;
    }
    .wine-guide-body {
        padding-top: 35px;
    }
    .wine-guide-left {
        width: 300px;
        display: inline-block;
    }
    .wine-guide-right {
        display: inline-block;
        width: calc(100% - 305px);
        vertical-align: top;
    }
    .wine-guide-left-title {
        font-weight: 600;
        color: #024E7B;
        font-size: 18px;
        height: 57px;
        line-height: 57px;
    }
    .wine-guide-country {
        display: block;
        height: 57px;
        line-height: 57px;
        text-decoration: none;
        color: #000;
        font-size: 16px;
        padding-left: 30px;
        width: 260px;
        border-left: 3px solid transparent;
    }
    .wine-guide-country:hover {
        border-color: #024E7B;
        background: #E5EDF2;
    }


</style>
